fragment RelatedProductsFragment on relatedProducts_Entry {
  typeHandle
}
